import { server as domain } from '../reducers/global';

const server = `https://${domain}`;

// 4xx系, 5xx系のエラーをさばくハンドラ
const handleErrors = async (response) => {
  if (!response.ok) {
    let errData = {};
    try {
      errData = await response.json();
    } catch (parseError) {
      // JSONパース失敗時は空オブジェクト
    }

    const message = Array.isArray(errData)
      ? errData.filter(Boolean).join('\n')
      : errData && typeof errData === 'object' && errData.message
      ? errData.message
      : typeof errData === 'string' && errData
      ? errData
      : `Request failed with status ${response.status}`;

    const error = new Error(message);
    error.data = errData;
    error.status = response.status;
    error.statusText = response.statusText;
    throw error;
  }
  return response;
};

// レスポンスに対して共通で行う前処理
const prepare = (response) => {
  console.info('ok?: ', response.ok, 'status: ', response.status);
  return response.json();
};

const prepareBlob = (response) => {
  console.info('ok?: ', response.ok, 'status: ', response.status);
  return response.blob();
};

const prepareText = (response) => {
  console.info('ok?: ', response.ok, 'status: ', response.status);
  return response.text();
};

export const superFetch = async (req, func = prepare) => {
  try {
    let reqUrl = req.server ? req.server + req.url : server + req.url;
    const custom = req.custom || {};
    const method = (req.type || 'GET').toUpperCase();
    const reqObj = Object.assign({}, custom, { method });

    if ((method === 'GET' || method === 'DELETE') && req.data) {
      if (typeof req.data === 'object') {
        const query = new URLSearchParams(req.data).toString();
        if (query) reqUrl += `?${query}`;
      } else {
        reqUrl += `${req.data}/`;
      }
    }

    if (['POST', 'PUT', 'PATCH'].includes(method)) {
      reqObj.headers = reqObj.headers || {};
      reqObj.headers.Accept = 'application/json';
      reqObj.headers['Content-Type'] = 'application/json';
      reqObj.body = JSON.stringify(req.data);
    }

    const response = await fetch(reqUrl, reqObj);
    const handledResponse = await handleErrors(response);
    const payload = await func(handledResponse);
    return { payload };
  } catch (err) {
    const error = err instanceof Error ? err : new Error(String(err));

    // サスペンド時等のネットワークエラー判定（TypeError かつ fetch 起因の例外）
    // ブラウザごとのメッセージ差異に対応するため includes や name で判定
    error.isNetworkError =
      error.name === 'TypeError' ||
      /failed to fetch|networkerror|load failed/i.test(error.message);

    return { err: error };
  }
};

export const superFetchText = (req) => superFetch(req, prepareText);
export const superFetchBlob = (req) => superFetch(req, prepareBlob);

export default superFetch;



// WEBPACK FOOTER //
// ./src/modules/superFetch.js